import React, { useState } from 'react'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { getConfirmOtp, getOtpDetails } from '../../redux/actions/recoverTicketAction'
import { Circles } from 'react-loader-spinner'
import { EMPTY_OBJECT, EVENT_LOG_TITLE, EMPTY_ARRAY } from '../../constants/globalConstants'
import { useEffect } from 'react'
import { dateFormatter, validateEmail } from '../../utils/helper'
import getConfigDetails from '../../services/config'
import { getUserIp, storeEventLog } from '../../redux/actions/eventLogActions'
import { downloadQrcodeRequest } from '../../redux/actions/paymentActions'
import OtpTimer from './OtpTimer'
import useNetwork from '../../hooks/NetworkDetector'



const phoneMaskGenerator = createDefaultMaskGenerator('(999) 9999-999')

function RecoverTicket(props) {
    const [bookingId, setBookingId] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [otp, setOtp] = useState('')
    const [isOtp, setIsOtp] = useState(false)
    const [isDownload, setIsDownload] = useState(false)
    const [promoLoader, setPromoLoader] = useState(false)
    const [eventDetails, setEventDetails] = useState(EMPTY_OBJECT)
    const [userIp, serUserIp] = useState()
    const [timer, setTimer] = useState(0)
    const [otpMessage, setOtpMessage] = useState()
    const [confirmOtpMessage, setConfirmOtpMessage] = useState()
    const [otpLoader, setOTPLoader] = useState(false)
    const [confirmOtpLoader, setConfirmOtpLoader] = useState(false)
    const [isReset, setIsReset] = useState(false)
    const { dispatch } = props
    const isOnline = useNetwork()


    useEffect(() => {
        dispatch(getUserIp()).then((res) => {
            serUserIp(res.IPv4)
        }).catch((err) => {
            console.log(err)
        })
    }, EMPTY_ARRAY)

    const handleInputChange = (e) => {
        const { name, value } = e.target
        if (name == 'otp') {
            setOtp(value)
        }
        if (name == 'booking_id') {
            setBookingId(value)
        }
        if (name == 'email') {
            setEmail(value)
        }
    }
    const handlePhoneChange = (value) => {
        setPhone(value.trim())
    }

    const bookingData = {
        'ticketech_code': bookingId,
        'email': email,
        'phone': phone,
    }


    const handleBookingInfo = (e) => {
        if(isOnline){
            setOtp('')
            setOtpMessage('')
            setConfirmOtpMessage('')
            if (bookingId != '' && bookingId != null && email != '' && email != null && validateEmail(email) && phone != '' && phone != null && phone.length >= 10) {
                setOTPLoader(true)
                dispatch(getOtpDetails(bookingData)).then((res) => {
                    setOTPLoader(false)
                    if (res?.status === 201) {
                        setTimer(60)
                        setIsOtp(true)
                        setOtpMessage(res.data)
                        setIsReset(true)
                    } else {
                        setTimer(0)
                        setIsOtp(false)
                        setOtpMessage(res.errors.message)
                        setIsReset(false)
                    }
                })
            } else {
                document.getElementById('ipg_form').reportValidity()

                // setError(true)
                if (bookingId == '' || bookingId == null) {
                    document.getElementById('booking_id').setCustomValidity('Please enter your booking Id.')
                } else if (phone == '' || phone == null || phone.length < 10) {
                    document.getElementById('phone').setCustomValidity('Please enter a valid phone number.')
                } else if (email == '' || email == null || !validateEmail(email)) {
                    document.getElementById('email').setCustomValidity('Please enter a valid email.')
                }
            }
        }
        e.preventDefault()
    }

    const handleOtpRemove = () => {
        setOtp('')
    }

    const handleOtpCode = (e) => {
        if(isOnline){
            const confirmOtpData = { ...bookingData, 'otp_number': otp }
            setConfirmOtpLoader(true)
            setOtpMessage('')
            dispatch(getConfirmOtp(confirmOtpData)).then((res) => {
                setConfirmOtpLoader(false)
                if (res?.status === 201) {
                    setEventDetails(res.data)
                    setIsDownload(true)
                    setOtpMessage('')
                    setConfirmOtpMessage('OTP verified successfully')
                } else {
                    setEventDetails(EMPTY_OBJECT)
                    setIsDownload(false)
                    setConfirmOtpMessage('Please enter a valid OTP')
                }
            })
        }
        e.preventDefault()
    }

    const getCard = (e, ID) => {
        if(isOnline){
            setConfirmOtpMessage('')
            setPromoLoader(true)
            const pdfName = `${bookingId}-${dateFormatter(eventDetails?.formatted_start_date, 'MM-DD-YYYY')}`
            const postData = {
                'facility_id': getConfigDetails.FACILITY_ID,
                'booking_id': bookingId,
                'phone': phone,
                'email': email,
            }
            const payload = {
                'error_message': JSON.stringify(postData),
                'event_name': EVENT_LOG_TITLE?.RE_DOWNLOAD_TICKET,
                'user_ip': userIp ? userIp : 'NA',
                'facility_id': getConfigDetails.FACILITY_ID
            }
            dispatch(storeEventLog(payload))

            dispatch(downloadQrcodeRequest(ID, pdfName, setPromoLoader))
        }
    }

    const onReset = () => {
        setIsOtp(false)
        setIsDownload(false)
        setIsReset(false)
        setBookingId('')
        setEmail('')
        setPhone('')
        setOtp('')
        setOtpMessage('')
        setConfirmOtpMessage('')
    }

    return (
        <div>
            <section className="top-section"><h1 className="text-center ">Download Ticket</h1></section>
            <div className="container-fluid pt-5 bg-primary  bg-opacity-10">
                <div className="row  justify-content-center">
                    <div className='col-md-6 mb-5'>
                        <div className="card shadow mb-5 mt-4  border-0 ">
                            <div className='card-header py-4 mb-0 text-center bg-white'><h3 className='text-primary mb-0 fw-bold '><i className='fas fa-download me-3'></i> Download Your Ticket</h3>
                                <small >Enter Your Booking Details below to download the ticket</small>
                            </div>
                            <div className='card-body px-5 pb-4 pt-2 '>
                                <form id='ipg_form'>
                                    <div className='my-3'>
                                        <div className='mb-3'>
                                            <label className="form-label" ><b>Booking ID</b></label>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text" id="basic-addon1"><i className="fa-solid fa-ticket"></i></span>
                                                <input
                                                    type="text"
                                                    name="booking_id"
                                                    id='booking_id'
                                                    value={bookingId}
                                                    className="form-control"
                                                    disabled={isOtp}
                                                    placeholder="Booking Id"
                                                    required
                                                    onInvalid={e => e.target.setCustomValidity('Please enter Booking ID')}
                                                    onInput={e => e.target.setCustomValidity('')}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className='mb-3'>
                                            <label className="form-label" ><b>Email Address</b></label>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text" id="basic-addon1"><i className="fa-regular fa-envelope"></i></span>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    id='email'
                                                    value={email}
                                                    disabled={isOtp}
                                                    className="form-control"
                                                    required
                                                    title="example@mail.xyz"
                                                    maxLength='40'
                                                    placeholder="Email Address"
                                                    onInvalid={e => e.target.setCustomValidity('Please enter email address')}
                                                    onInput={e => e.target.setCustomValidity('')}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className='mb-3'>
                                            <label className="form-label"><b>Phone Number</b></label>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text" id="basic-addon1"><i className="fa-solid fa-phone"></i></span>
                                                <MaskedInput
                                                    maskGenerator={phoneMaskGenerator}
                                                    value={phone}
                                                    type="text"
                                                    name="phone"
                                                    id='phone'
                                                    className="form-control"
                                                    required
                                                    disabled={isOtp}
                                                    maxLength={14}
                                                    title="Please enter a valid phone number"
                                                    onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                                    onInput={e => e.target.setCustomValidity('')}
                                                    placeholder="Phone Number"
                                                    onChange={handlePhoneChange}
                                                />
                                            </div>
                                        </div>
                                        {!isOtp && <button type='button' onClick={handleBookingInfo} className="btn btn-primary mb-3 w-100">Submit</button>}
                                    </div>
                                </form>

                                {/* confirm otp input box */}
                                {isOtp &&
                                    <form>
                                        <div className="mb-3">
                                            <div className="">
                                                <label className="mb-1"><b>Verify OTP</b></label>
                                                <div className="input-group mb-1 d-flex">
                                                    <input
                                                        type="text"
                                                        name="otp"
                                                        value={otp}
                                                        className='form-control'
                                                        placeholder="Enter Your OTP"
                                                        disabled={isDownload}
                                                        required
                                                        pattern="[0-9 ]{6}"
                                                        maxLength='6'
                                                        minLength='6'
                                                        aria-label="otp"
                                                        aria-describedby="basic-addon1"
                                                        onChange={handleInputChange}
                                                    />
                                                    <button className="input-group-text" id="basic-addon1" type='button' disabled={isDownload} onClick={handleOtpRemove}>X</button>
                                                    <button className="btn btn-primary ms-5" type='submit' onClick={handleOtpCode} disabled={isDownload}>Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>}
                                <div className='mb-3 d-flex justify-content-between'>
                                    <div>
                                        {(isOtp && !isDownload) &&
                                            < OtpTimer
                                                text='Resend Otp'
                                                timer={timer}
                                                setTimer={setTimer}
                                                timerAction={handleBookingInfo}
                                            />
                                        }
                                        <div className='mt-3'>
                                            {isDownload && <button className="btn btn-primary d-inline-flex" disabled={promoLoader ? 'disabled' : null} onClick={(e) => getCard(e, eventDetails?.reservation_id)} >
                                                <i className='fas fa-download me-2 mt-1 ' />Download Ticket {' '}{promoLoader && <span className=' ms-2'><Circles
                                                    height="20"
                                                    width="20"
                                                    color="#060D63"
                                                    ariaLabel="circles-loading"
                                                    visible={true}
                                                /></span>}
                                            </button>}
                                        </div>
                                    </div>
                                    <div>
                                        {isReset && <button type='button' className="btn btn-outline-primary float-end" onClick={onReset}
                                        >Reset</button>}
                                    </div>
                                </div>

                                <div className=''>
                                    {otpLoader ?
                                        <span className='d-flex'><Circles
                                            height="20"
                                            width="20"
                                            color="#060D63"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /><span className='ms-2'>Loading...</span></span> :
                                        <div className={(isOtp) ? ' text-success ' : 'text-danger '}>{otpMessage}</div>
                                    }

                                    {confirmOtpLoader ?
                                        <span className='d-flex'><Circles
                                            height="20"
                                            width="20"
                                            color="#060D63"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /><span className='ms-2'>Loading...</span></span> :
                                        <span className={(isDownload) ? ' text-success' : 'text-danger'}>{confirmOtpMessage}</span>
                                    }
                                </div>
                            </div>
                        </div></div>
                </div>
            </div>
        </div>
    )
}

RecoverTicket.propTypes = {
    dispatch: PropTypes.func,
}


RecoverTicket.defaulProps = {
    dispatch: noop,
}

function mapStateToProps() {
    return {

    }
}
export default connect(mapStateToProps)(RecoverTicket)
